import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { SnackBarIconService } from '../shared/snack-bar-icon/snack-bar-icon.service';
import { Webnar } from '../models/webnar';
import { WebnarDialogComponent } from './dialogs/webnar-dialog/webnar-dialog.component';
import { WebnarService } from '../services/webnar.service';
import { MatPaginator } from '@angular/material/paginator';
import { Subscription } from 'rxjs';
import { ConfirmComponent } from '../shared/dialogs/confirm/confirm.component';

import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { WebnarViewDialogComponent } from './dialogs/webnar-view-dialog/webnar-view-dialog.component';

@Component({
  selector: 'app-webnar',
  templateUrl: './webnar.component.html',
  styleUrls: ['./webnar.component.scss'],
  entryComponents: [
    WebnarDialogComponent
  ]
})
export class WebnarComponent implements OnInit {

  private sub: Subscription;
  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = ['icon', 'name', 'preview', 'edit', 'delete'];

  constructor(
    private _webnarService: WebnarService,
    private dialog: MatDialog,
    private snackBar: SnackBarIconService,
    private _authService: AuthService,
    private router: Router
  ) {

    if (!this._authService.isAdmin) {
      this.router.navigate(['home']);
    }

    this.loadWebnars()
  }

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.sub)
      this.sub.unsubscribe();
  }

  loadWebnars() {

    this.sub = this._webnarService.select()
      .subscribe((result) => {
        let array = result.map(item => {
          let entity = new Webnar();
          entity.id = item.payload.doc.id;
          entity.name = item.payload.doc.data().name;
          entity.name_en = item.payload.doc.data().name_en;
          entity.url = item.payload.doc.data().url;
          entity.created = item.payload.doc.data().created;
          return entity;
        });

     //   console.log("array: " + JSON.stringify(array))

        setTimeout(() => {
          this.dataSource = new MatTableDataSource(array);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        });


      },
        (error) => {
          console.log(JSON.stringify(error))
          this.snackBar.openSnackBar("Acesso negado", '', 'error');
        })

  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  openDialog(entity) {

    let data: Webnar = new Webnar();

    if (entity) {
      data = entity;
    }

    this.dialog.open(WebnarDialogComponent, {
      width: '800px',
      height: '600px',
      panelClass: 'custom-dialog-container',
      data: data
    });
  }


  delete(element) {
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: { title: "Confirme", message: element.name + "<br><br>Excluir este webnar?" }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._webnarService.delete(element.id)
          .then(
            () => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => { console.log("delete webnar error: " + error.message) }
          )
      }
    })
  }

  preview(element) {

    this.dialog.open(WebnarViewDialogComponent, {
      width: '800px',
      height: '600px',
      panelClass: 'custom-dialog-container',
      data: element
    });

  }

}
